<div class="enquiry-dialog">
    <div class="enquiry-header">
        <h1 class="mat-title-large" *ngIf="submitState === 'idle'">Enquire with us</h1>
        <h1 class="mat-title-large" *ngIf="submitState === 'success'">Thank you</h1>
        <h1 class="mat-title-large" *ngIf="submitState === 'error'">Message not sent</h1>
        <button mat-icon-button type="button" class="close-btn" (click)="close()" aria-label="Close">
            <mat-icon>close</mat-icon>
        </button>
    </div>

    <form *ngIf="submitState === 'idle'" [formGroup]="form" novalidate (ngSubmit)="submit()">
        <div class="enquiry-fields">
            <app-form-field label="Full name" [control]="form.controls.fullName" [formSubmitted]="form.touched">
            </app-form-field>

            <app-form-field label="Email" type="email" [control]="form.controls.email"
                [formSubmitted]="form.touched">
            </app-form-field>

            <app-form-field label="Mobile" [control]="form.controls.mobile" [formSubmitted]="form.touched">
            </app-form-field>

            <app-form-field-currency label="Amount to borrow" [control]="form.controls.amountToBorrow"
                [decimal_precision]="0">
            </app-form-field-currency>

            <app-form-field label="Describe your loan" [control]="form.controls.loanDescription" [isMultiLine]="true"
                [textAreaRows]="4" [formSubmitted]="form.touched">
            </app-form-field>
        </div>

        <div class="turnstile-container">
            <div #turnstileWidget></div>
            <p class="turnstile-error" *ngIf="turnstileError">
                Please complete the security check before submitting.
            </p>
        </div>

        <button mat-flat-button type="submit" class="send-btn">Send enquiry</button>
    </form>

    <!-- Success -->
    <div *ngIf="submitState === 'success'" class="result-message">
        <p class="mat-body-large">We've received your enquiry and will be in touch with you shortly.</p>
        <button mat-flat-button type="button" class="send-btn" (click)="close()">Close</button>
    </div>

    <!-- Error -->
    <div *ngIf="submitState === 'error'" class="result-message">
        <p class="mat-body-large" *ngIf="errorMessage">{{ errorMessage }}</p>
        <p class="mat-body-large" *ngIf="!errorMessage">
            Something went wrong and your message could not be sent. Please try again later or contact us directly.
        </p>
        <button mat-flat-button type="button" class="send-btn" (click)="close()">Close</button>
    </div>
</div>
